export const PostFlow = (builder) => ({
    PostFlow: builder.mutation({
        query: (body) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: process.env.REACT_APP_CHATBOT_API_PORT + '/chat/createFlow',
                method: 'POST',
                body: body,
                headers: {
                    'Authorization': token,
                },
            };
        },
    }),
});
